import React from "react"
import { Types } from "lib/@types"
import { useAppCtx, appStore } from "lib/state"
import { randoms, OPERATORS } from "lib/utils"
import { useConditional } from "."
import { useConditionalCtx } from "lib/units/dispute/statements/conditionals"


export default function useClipboard(){

  const { appState, appTools }:any = useAppCtx()

  const { store, AppStore }:any = appStore()
  const { closeModal }:any = useConditional()
  const { usage, currentConditional, updateConditional }:any = useConditionalCtx()

  const { update }:any = AppStore

  /**
   * After a tag has been selected in the modal, this function
   * adds the tag to the clipboard
   * @param tag 
   */
  function addTagToClipboard(tag:any){
    console.log(tag)
    const tagObj = {
      refid: randoms.string(12, "a#"),
      source: "tag",
      operator: "mustExist",
      value: tag,
      tag: `Tag: ${tag.label}`,
      location: "clipboard"
    }

    const newClipboard = [...currentConditional.clipboard, tagObj]
    console.log(newClipboard)
    updateConditional({ ...currentConditional, clipboard: newClipboard })

    // update("actives.statement.conditional.clipboard", [...currentConditional.clipboard, tagObj])
    closeModal()
  }



  /**
   * When the tags button is clicked in the clipboard area, 
   * this function determines what tags should be displayed 
   * in the modal
   */
  function getQueryableTags(){
    let tagsOwned:any[] = [] 
    if( store.template?.Tags !== undefined && store.template?.Tags.length > 0 ){
      tagsOwned = [...tagsOwned, ...store.template?.Tags ]
    }
    if( store.template?.AssignedTo?.tags.length > 0 ){
      tagsOwned = [...tagsOwned, ...store.template?.AssignedTo?.tags ]
    }
    return tagsOwned
  }


  /**
   * Determines if an item in the clipboard is ready to be dragged into the dropzone
   * @param item
   * @returns boolean
   */
  function clipboardItemIsReady(item:Types.Conditional.ClipboardItem){
    const operatorObj:any = OPERATORS.find( (op:any) => op.value === item.operator )
    if( item.source === "tag" ) return true
    if( item.operator === undefined 
        || item.operator.length === 0 
        || ( operatorObj.requiresValue && item.value === undefined )
        || ( operatorObj.requiresValue && item.value.length === 0 )
    ){
      return false
    } else {
      return true
    }
  }

  // function copyToClipboard( data:any ){
  //   setClipboard(data)
  // }

  return {
    addTagToClipboard,
    clipboardItemIsReady,
    getQueryableTags
  }
}